// extracted by mini-css-extract-plugin
export default {"novaCategoria":"styles_novaCategoria__YKYqL","listagem":"styles_listagem__iPLyq"};